import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const checkUserStorageSession = () => apiActionCreator({
  'endpoint': '/storageProcesses',
  'authenticated': true,
  'types': [
    ActionTypes.CHECKING_USER_STORAGE_SESSION,
    ActionTypes.CHECKED_USER_STORAGE_SESSION,
    [
      ActionTypes.CHECKED_USER_STORAGE_SESSION_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPendingLinesToStorageByCar = (storageCar, status) => {
  const queryString = status ? `?status=${status}` : '';
  return apiActionCreator({
    'endpoint': `/storageProcesses/cars/${storageCar}/lines${queryString}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PENDING_LINES_TO_STORAGE_BY_CAR,
      {
        'type': ActionTypes.FETCHED_PENDING_LINES_TO_STORAGE_BY_CAR,
        'payload': storageCar,
      },
      [
        ActionTypes.FETCHED_PENDING_LINES_TO_STORAGE_BY_CAR_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
